import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import ListItem from './ListItem';

import { getTimezoneNameByCode } from '../../../shared/Helpers';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  headerText: {
    textAlign: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  loadingSpinner: {
    margin: theme.spacing(5),
    height: 50,
    width: 50,
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(3 * 2))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
      maxWidth: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  list: {
    width: '100%',
  },
  loadingSpinnerContainer: {
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
  },
  nextPageContainer: {
    textAlign: 'center',
  },
});

class ClassList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const {
      classes,
      loading,
      pageLoading,
      userTimezone,
      currentDay,
      getNextPage,
      morePagesAvailable,
      ordering,
      events,
      handlePopupOpen,
    } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.appBarSpacer} />
        <div className={classes.headerText}>
          <Typography color="textSecondary">{'Showing times in ' + getTimezoneNameByCode(userTimezone)}</Typography>
          <Typography color="textSecondary">{ordering === 'time' ? 'Sorted by Date' : 'Sorted by Location'}</Typography>
        </div>
        {loading
          ? (
            <Paper className={classes.paper} elevation={1}>
              <div className={classes.loadingSpinnerContainer}>
                <CircularProgress color="secondary" className={classes.loadingSpinner} />
              </div>
            </Paper>
          )
          : (
            <Grid justifyContent="center" container spacing={3}>
              {events.length < 1
                ? (
                  <Typography variant="h6" className={classes.noTrainingsText}>Your search returned no Trainings</Typography>
                )
                : (
                  <List className={classes.list}>
                    {events.map(event => (
                      <ListItem
                        key={event.id}
                        userTimezone={userTimezone}
                        currentDay={currentDay}
                        event={event}
                        handlePopupOpen={handlePopupOpen}
                      />
                    ))}
                    <div className={classes.nextPageContainer}>
                      {pageLoading
                        ? (
                          <CircularProgress color="secondary" />
                        )
                        : (
                          <Button
                            onClick={getNextPage}
                            disabled={!morePagesAvailable}
                          >
                            Load More
                          </Button>
                        )
                      }
                    </div>
                  </List>
                )
              }
            </Grid>
          )
        }
      </div>
    );
  }
}

ClassList.propTypes = {
  currentDay: PropTypes.string.isRequired,
  getNextPage: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  pageLoading: PropTypes.bool.isRequired,
  events: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  userTimezone: PropTypes.string.isRequired,
  morePagesAvailable: PropTypes.bool.isRequired,
  ordering: PropTypes.string.isRequired,
  handlePopupOpen: PropTypes.func.isRequired,
};

export default withStyles(styles)(ClassList);
